import React from 'react';
import {
  useLocation,
} from 'react-router';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';

const NoPointsWidget: React.FC<WidgetProps> = (props: WidgetProps) => {

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const paramLang = queryParams.get('lang');

  const {
    widgetParams,
    defaultPaddings,
  } = props;

  return (
    <div
      style={defaultPaddings}
      className={styles.noPoints}
    >
      <div className={styles.cardBody}>
        <div>
          <h5>
            {paramLang === 'en' ? 'You have not any points' : 'ليس لديك نقاط'}
          </h5>
          <p>
            {
            paramLang === 'en'
              ? 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.'
              : 'و بشكله الاصلي في الطباعة والتنضيد الالكتروني صار مستخدما'
          }
          </p>
        </div>
      </div>
      <div className={styles.button}>
        <h5>{paramLang === 'en' ? 'Collect Points' : 'جمع نقاط'}</h5>
      </div>
    </div>
  );
};

export default NoPointsWidget;
